<template>
    <div>
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5">Sebab Tidak Ditemukan <span
                    class="text-danger">*</span></span>
            <div class="col-12 mt-50">
                <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                    <b-form-radio v-model="formDatas.sebab_tidak_ditemukan" value="hilang-tidak-ditemukan" disabled>
                        Hilang Tidak Ditemukan
                    </b-form-radio>
                    <b-form-radio v-model="formDatas.sebab_tidak_ditemukan" value="hilang-karena-kecurian" disabled>
                        Hilang Karena Kecurian
                    </b-form-radio>
                    <b-form-radio v-model="formDatas.sebab_tidak_ditemukan" value="usang-hancur" disabled>
                        Usang/Hancur
                    </b-form-radio>
                    <b-form-radio v-model="formDatas.sebab_tidak_ditemukan" value="keadaan-kahar" disabled>
                        Keadaan Kahar (Force Majeure)
                    </b-form-radio>
                    <b-form-radio v-model="formDatas.sebab_tidak_ditemukan"
                        value="dipindahtangankan-dimusnahkan-belum-dihapus" disabled>
                        Dipindahtangankan/Dimusnahkan, Belum dihapus
                    </b-form-radio>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5">Kronologis <span class="text-danger">*</span></span>
            <div class="col-12 mt-50">
                <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                    <div class="border border-1 rounded p-75 bg-light">
                        <span>{{ formDatas.kronologis || '-' }}</span>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="formDatas.sebab_tidak_ditemukan == 'dipindahtangankan-dimusnahkan-belum-dihapus'">
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">Dokumen SK <span class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                    <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                        <b-form-radio v-model="formDatas.is_dokumen_pendukung_sk" value="tidak" disabled>
                            Tidak Ada SK
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.is_dokumen_pendukung_sk" value="iya" disabled>
                            Ada Dokumen SK
                        </b-form-radio>
                    </div>
                </div>
            </div>
            <div class="row mb-2" v-if="formDatas.is_dokumen_pendukung_sk == 'iya'">
                <span class="col-12 font-weight-bold font-small-5">Upload Dokumen SK <span
                        class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                    <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                        <a target="_blank" :href="formDatas.file_dokumen_sk" class="cursor-pointer text-primary"> Download
                            Dokumen</a>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">Dokumen Pendukung <span
                        class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                    <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                        <b-form-radio v-model="formDatas.is_dokumen_pendukung_sk" value="tidak" disabled>
                            Tidak Ada
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.is_dokumen_pendukung_sk" value="iya" disabled>
                            Ada Dokumen Pendukung
                        </b-form-radio>
                    </div>
                </div>
            </div>
            <div class="row mb-2" v-if="formDatas.is_dokumen_pendukung_sk == 'iya'">
                <span class="col-12 font-weight-bold font-small-5">Dokumen Pendukung Berupa <span
                        class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                    <div class="border border-1 rounded p-75 bg-light">
                        <span>{{ formDatas.dokumen_pendukung_berupa || '-' }}</span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
  
<script>
import { ref, watch, watchEffect } from '@vue/composition-api'
import vSelect from "vue-select";
import { id as localeId } from "vee-validate/dist/locale/id";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import daftarBmd from "@/composables/b/daftarBmd";
import { showNotifikasi } from '@/libs/helper';
import { VueGoodTable } from "vue-good-table";
import { parserValue } from '@/libs/helper'

export default {
    props: {
        fD: {
            type: Object,
            required: true,
        },
        disabled: { type: Boolean, default: false },
        updateItem: Function,
    },
    setup(props, context) {
        localize('id', localeId);
        const g = context.root;
        const formDatas = ref(props.fD);
        return {
            formDatas
        }
    },
    computed: {
    },

    components: {
    },
    directives: {
        Ripple,
    },
    methods: {
    },
    data() {
        return {
            required,
        }
    },
}
</script>

<style lang="scss" scope>
.custom-control.custom-radio input:checked+.custom-control-label::before {
    background-color: var(--primary) !important;
}

.custom-control.custom-radio input:checked+.custom-control-label {
    color: var(--text-dark) !important;
}
</style>